exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-demo[data-v-635b4cea] {\n  display: inline-block;\n  margin-left: 10px;\n}\n.my-box .my-card[data-v-635b4cea] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-635b4cea] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-635b4cea]:last-child {\n    margin-bottom: 0;\n}\n.my-box .grid-content[data-v-635b4cea] {\n  border-radius: 4px;\n  height: 36px;\n  white-space: nowrap;\n}\n.my-box .grid-content .el-input__inner[data-v-635b4cea] {\n    max-width: 190px;\n}\n.my-box .grid-content span[data-v-635b4cea] {\n    font-size: 14px;\n}\n", ""]);

// exports
